import {ThemeBorderWidthNames} from '../../types/ThemeBorder';

export const Borders: ThemeBorderWidthNames = {
  '1': 1,
  '2': 2,
  '4': 4,
  '6': 6,
};
